import { Directive, ElementRef, Renderer2, Input, AfterViewInit, OnChanges, SimpleChanges } from '@angular/core';
import * as d3 from 'd3';

@Directive({
  selector: '[ctlDonutChart]'
})
export class DonutChartDirective implements AfterViewInit, OnChanges {
  colors = ['#8c60a8', '#bf93db', '#e8d6f2'];
  margin = 0;
  hole = 0;

  @Input('ctlDonutChart') opt: any = {};
  @Input('ctlData') data: any = [];
  @Input('fontSize') fontSize: any = [];

  private dataseries: any;

  title = 'Donut Chart';

  private width = 250;
  private height = 250;

  private svg: any;     // TODO replace all `any` by the right type

  private radius = 0;

  private arc: any;
  private pie: any;
  private color: any;

  private g: any;
  private tooltip: any;

  private total: string;
  private totalText: string;
  private totalAct: string;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2) {
  }

  ngAfterViewInit() {
    this.totalText = 'Total Logins';
    if (this.data && this.data.length > 0) {
      this.initSvg();
      this.drawChart(this.data);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (typeof changes['data'] !== 'undefined') {
      // retrieve the quiz variable change info
      const change = changes['data'];

      // only perform the task if the value has been changed
      if (!change.isFirstChange()) {
          // execute the Http request and retrieve the result
          this.initSvg();
          this.drawChart(this.data);
      }
    }
  }

  private initSvg() {
    const self = this;
    let selector = '.donut';

    if (self.opt && self.opt.selector) {
      selector = self.opt.selector;
    }

    if (self.opt && self.opt.hole) {
      self.hole = self.opt.hole;
    }

    if (self.opt && self.opt.width) {
      self.width = self.opt.width;
    }

    if (self.opt && self.opt.height) {
      self.height = self.opt.height;
    }

    if (self.opt && self.opt.totalText) {
      self.totalText = self.opt.totalText;
    }

    if (self.opt && self.opt.colors) {
      self.colors = self.opt.colors;
    }

    if (self.opt && self.opt.totalText) {
      self.totalText = self.opt.totalText;
    }

    if (self.opt && self.opt.total) {
      self.totalAct = self.opt.total;
    }

    d3.select('#' + selector).select('svg').remove();

    self.svg = d3.select('#' + selector);

    self.radius = Math.min(self.width, self.height) / 2;

    self.color = d3.scaleOrdinal()
      .range(self.colors);

    self.arc = d3.arc()
      .outerRadius(self.radius)
      .innerRadius(self.hole);

    self.pie = d3.pie()
      .sort(null)
      .value((d: any) => d.count);

    self.tooltip = d3.select('#' + selector)
      .append('div')
      .attr('class', 'tooltip')
      .style('display', 'none');



    self.svg = self.svg.append('svg')
      .attr('width', self.width)
      .attr('height', self.height)
      .append('g')
      .attr('transform', 'translate(' + self.width / 2 + ',' + self.height / 2 + ')');
  }

  private drawChart(data: any[]) {
    const self = this;

    /* for (let index = 0; index < data.length; index++) {
      const element = data[index];
      self.total = self.total + element.count;
    } */
    if (self.totalAct && self.totalAct === 'sum' ) {
      self.total = self.totalSum(data) + '';
    }

    if (self.totalAct && self.totalAct === 'percentage' ) {
      self.total = self.totalPercentage(data) + '%';
    }

    self.svg.append('text')
      .attr('text-anchor', 'middle')
      .attr('fill', '#f2f2f2')
      .attr('font-size', this.fontSize)
      .attr('font-weight', 300)
      .attr('dy', '.3em')
      .text(self.total);

    self.svg.append('text')
      .attr('text-anchor', 'middle')
      .attr('fill', '#f2f2f2')
      .attr('opacity', '0.6')
      .attr('font-size', '16px')
      .attr('font-weight', 300)
      .attr('dy', '3em')
      .text(self.totalText);

    const g = self.svg.selectAll('.arc')
      .data(self.pie(data))
      .enter().append('g')
      .attr('class', 'arc');

    g.append('path')
      .attr('d', self.arc)
      .style('fill', (d: any) => self.color(d.data.id))
      .on('mouseover', (d) => {
        self.mouseoverD3();
      })
      .on('mousemove', (d) => {
        self.mousemoveD3(d);
      })
      .on('mouseout', (d) =>{
        self.mouseoutD3();
      });
  }

  private mouseoverD3() {
    this.tooltip
      .style('display', 'inline-block')
      .style('position', 'absolute');
  }

  private mousemoveD3(d) {
    this.tooltip
      .html('<div style="background-color: #ffffff; color: #181818;padding: 5px;">' + d.data.id + ', ' + d.data.count + '</div>')
      .style('left', d3.event.pageX + 15 + 'px')
      .style('top', d3.event.pageY + 15 + 'px');
  }

  private mouseoutD3() {
    this.tooltip
      .style('display', 'none');
  }

  private totalSum(data) {
    return d3.sum(data, (d: any) => parseInt(d.count));
  }

  private totalPercentage(data) {
    if (data[0].count > data[1].count) {
      return Math.round((data[1].count / data[0].count) * 100 );
    }
  }
}
